"use client";
import Image from "next/image";
import TextZone from "./TextZone";
import { usePathname } from "next/navigation";
import Link from "next/link";
import { useContext } from "react";
import { GlobalContext } from "@/context";
import axios from "axios";

const NavbarHorizontal = () => {
  const { setConnected, setUserData } = useContext(GlobalContext);
  const pathname = usePathname();

  const logout = async() => {
    try {
    await axios.get(`${process.env.NEXT_PUBLIC_URL}/auth/logout`, {
      withCredentials: true, 
    });
    localStorage.clear();
    setConnected(false);
    setUserData(false);
  } catch (err) {
    console.error('Logout failed:', err);
  }
   
  };
  return (
    <>
      {pathname == "/" ? null : (
        <div className="flex relative justify-end gap-8 w-full z-0 items-center mt-4 pr-5">
          <Image
            src="/logout.png"
            width={1000}
            height={1000}
            alt="Se déconnecter"
            className="w-[30px] h-[30px] cursor-pointer"
            onClick={logout}
            title="Déconnecter"
          />
          <Link href="/reglage">
            <Image
              src="/setting.png"
              width={1000}
              height={1000}
              alt="Paramètres"
              className="w-[26px] h-[26px]"
              title="Réglage"
            />
          </Link>

          <Link href={"/dashboard"}>
            <Image
              src={"/logo.png"}
              width={1000}
              height={1000}
              alt="Logo pour revenir à la page d'accueil"
              className="w-[160px] h-[90px] object-contain"
              title="tableau de bord"
            />
          </Link>
        </div>
      )}
    </>
  );
};
export default NavbarHorizontal;
